var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNamePlate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 86,
    viewBox: "0 0 121 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3815_63172)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.4902 8.83086C35.4902 3.9569 39.3863 0 44.2011 0C49.016 0 52.9121 3.9569 52.9121 8.83086C52.9121 13.7048 49.016 17.6617 44.2011 17.6617C39.3863 17.6617 35.4902 13.7048 35.4902 8.83086Z",
    fill: "#D8202A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.97553 16.1677C6.97553 16.1677 5.39328 9.69739 0 11.8881C0 11.8881 5.46133 12.8901 3.81102 20.3623C2.16071 27.8346 7.04359 30.8405 8.55779 30.7046C8.55779 30.7046 9.13625 19.0038 18.7659 18.0867C27.9872 17.2206 32.2066 27.2912 31.4069 30.2971C31.4069 30.2971 37.0044 20.2944 26.9324 12.8222C16.7413 5.26498 7.36685 15.2167 6.97553 16.1507V16.1677Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2193 30.6533C31.2193 30.6533 13.4062 55.2099 48.6241 85.014C48.6241 85.014 27.017 77.4569 18.8505 61.5274C10.9903 46.1922 20.7901 32.4365 31.2193 30.6533Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0668 85.099C49.0668 85.099 37.2594 72.566 34.3161 58.3177C31.5089 44.6978 35.2859 31.4515 46.0044 25.6605C46.0044 25.6605 55.9743 19.1732 73.226 22.9094C86.8368 25.8473 108.971 30.2118 121 16.7617C121 16.7617 118.55 34.9159 96.9428 40.1635C96.9428 40.1635 89.5589 41.7598 79.7251 40.7918C69.8913 39.8069 54.8684 35.1027 46.3446 43.8147C37.8209 52.5267 42.9249 72.6339 49.0668 85.099Z",
    fill: "#004098"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0661 84.6569C49.0661 84.6569 47.4328 66.3668 57.8451 58.9455C67.5938 51.9997 82.3445 62.9534 95.53 49.2486C95.53 49.2486 90.2898 51.4053 79.7245 49.8769C70.5542 48.5523 56.2288 42.7613 49.2533 53.7998C42.601 64.3289 49.0831 84.6739 49.0831 84.6739L49.0661 84.6569Z",
    fill: "#004098"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3815_63172"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 121,
    height: 85.0989,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNamePlate);
export default __webpack_public_path__ + "static/media/icon_name_plate.879489f0fd694ed72d95da72736818ee.svg";
export { ForwardRef as ReactComponent };